export default "__VITE_ASSET__9ff81f97__"